import { render, staticRenderFns } from "./PortalNotification.vue?vue&type=template&id=7f80d7c6&scoped=true&"
import script from "./PortalNotification.vue?vue&type=script&lang=js&"
export * from "./PortalNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f80d7c6",
  null
  
)

export default component.exports